
export default function SpeedGuide() {
  const steps = [
    {
      icon: 'ri-smartphone-line',
      title: 'オンラインで申込',
      description: '公式サイトから必要情報を入力して申込',
    },
    {
      icon: 'ri-time-line',
      title: '最短5分で審査完了',
      description: 'スピード審査でカード番号を即時発行',
    },
    {
      icon: 'ri-apps-line',
      title: '公式アプリで確認',
      description: 'アプリでカード番号をすぐに確認可能',
    },
    {
      icon: 'ri-shopping-cart-line',
      title: 'すぐに利用開始',
      description: 'ネットショッピングやスマホ決済で即利用',
    },
  ];

  const useCases = [
    {
      icon: 'ri-shopping-bag-line',
      title: 'ネットショッピング',
      description: 'Amazon、ECモールなどですぐに買い物',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Apple Pay / Google Pay',
      description: 'スマホに登録してタッチ決済',
    },
    {
      icon: 'ri-store-line',
      title: 'QUICPay加盟店',
      description: 'コンビニなどでスマホ決済',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-3 text-center">
          スピード発番「スピ発」の流れ
        </h2>
        <p className="text-gray-600 text-center mb-12">最短5分でカード番号発行、すぐに使える！</p>

        <div className="bg-gradient-to-r from-[#E8F5E9] to-[#F8F9FA] rounded-2xl p-8 mb-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-xl p-4 text-center shadow-md h-full">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#00A651] rounded-full mx-auto mb-3">
                    <i className={`${step.icon} text-white text-xl`}></i>
                  </div>
                  <div className="bg-[#003366] text-white text-xs font-bold px-2 py-1 rounded-full inline-block mb-2">
                    STEP {index + 1}
                  </div>
                  <h4 className="text-[#003366] font-bold text-sm mb-1">{step.title}</h4>
                  <p className="text-gray-600 text-xs">{step.description}</p>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-2 transform -translate-y-1/2 z-10">
                    <i className="ri-arrow-right-s-line text-[#00A651] text-2xl"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="bg-[#F8F9FA] rounded-xl p-6 md:p-8">
          <h3 className="text-xl font-bold text-[#003366] mb-6 text-center">
            <i className="ri-flashlight-line text-[#00A651] mr-2"></i>
            カード番号発行後すぐに使える場所
          </h3>
          <div className="grid md:grid-cols-3 gap-4">
            {useCases.map((useCase, index) => (
              <div key={index} className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#00A651]/10 rounded-full flex-shrink-0">
                    <i className={`${useCase.icon} text-[#00A651] text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="text-[#003366] font-bold text-sm">{useCase.title}</h4>
                    <p className="text-gray-600 text-xs">{useCase.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 bg-[#FFF8E1] border-l-4 border-[#FF9900] rounded-lg p-4">
          <p className="text-[#003366] text-sm">
            <i className="ri-information-line mr-1 text-[#FF9900]"></i>
            <strong>注意：</strong>スピード発番は9:00〜20:00の受付となります。時間外の申込は翌日以降の発行となる場合があります。
          </p>
        </div>
      </div>
    </section>
  );
}
